import {
  StyleSheet,
  SafeAreaView,
  ImageBackground,
  useWindowDimensions,
} from "react-native";
import React, { useEffect, useState } from "react";
import { Box, ScrollView, View, Text, HStack } from "native-base";
import { StackScreenProps } from "../../types";
import Header from "../../components/Header";
import Swiper from "react-native-web-swiper";
import CountUp from "react-countup";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { RenderItem } from "../../components/RenderItem";

const Agripromoters = ({ navigation }: StackScreenProps<"ResearchAndDev">) => {
  const { width, height } = useWindowDimensions();

  const [data, setData] = useState({});
  useEffect(() => {
    async function getData() {
      const items = await AsyncStorage.getItem("keyFigures");

      if (items) {
        try {
          setData(JSON.parse(items));
          // console.log(JSON.parse(items));
        } catch (error) {
          console.log(error);
        }
      }
    }

    getData();
  }, []);

  type RenderItemProps = {
    item: any[];
    index: number;
  };
  const renderItem = ({ item, index }: RenderItemProps) => (
    <Box w={"2/3"} h={350} margin="auto" key={index} alignSelf="center">
      <ImageBackground
        source={item}
        resizeMode="contain"
        style={{
          width: "100%",
          height: "100%",
        }}
        imageStyle={{}}
      ></ImageBackground>
    </Box>
  );

  type Section = {
    title: string;
    content: string[];
    index: number;
  };
  const SECTIONS = [
    {
      title: "Agripromoter Value Addition",
      content: [
        "- Farmer Training and Extension Services",
        "- Data Collection",
        "- Farm Input Redistribution",
        "- Demo Plots",
        "- Mechanization and Irrigation Services",
      ],
      index: 0,
    },
  ];

  const renderContent = (section: Section) => {
    return (
      <View style={styles.content}>
        {section.content.map((item) => (
          <Text key={item} fontWeight={"bold"}>
            {item}
          </Text>
        ))}
      </View>
    );
  };

  return (
    <ImageBackground
      source={require("../../assets/truck.png")}
      resizeMode="cover"
      style={{ width, height }}
    >
      <View style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <ScrollView>
            <Header
              onPress={() => navigation.navigate("Distribution")}
              parentText="Last-Mile Distribution"
              headingText="OCP Agripromoters"
              intro=""
            />

            <Text mb={5} textAlign="center" fontWeight={"bold"}>
              Key figures:
            </Text>

            <Box
              width={"90%"}
              // h="16"
              mb={5}
              margin="auto"
              // borderBottomColor="#000"
              borderColor={"#ccc"}
              borderWidth="1"
              borderRadius={15}
              p={5}
              pb={2}
            >
              <HStack justifyContent={"space-between"}>
                <View>
                  <Text fontWeight={"extrabold"} fontSize="2xl">
                    <CountUp delay={0} end={data["agripromoters_1"]} />
                  </Text>
                  <Text fontWeight={"bold"}>Agripromoters</Text>
                </View>
                <View>
                  <Text fontWeight={"extrabold"} fontSize="2xl">
                    <CountUp
                      delay={0}
                      end={data["agripromoters_2"]}
                      suffix="+"
                    />
                  </Text>
                  <Text fontWeight={"bold"}>Farmers Trained</Text>
                </View>
                <View>
                  <Text fontWeight={"extrabold"} fontSize="2xl">
                    <CountUp delay={0} end={data["agripromoters_3"]} />
                  </Text>
                  <Text fontWeight={"bold"}>Demo Plots</Text>
                </View>
              </HStack>
            </Box>

            <Text textAlign="center" mb={6} px={4}>
              Agripromoters are foot soldiers (entrepreneurs) attached to a Farm
              and Fortune Hub whose responsibility is to train farmers on Good
              Agricultural Practices, distribute of farm inputs and develop
              demonstration plots for farmers to practically learn on the field.
              They are equipped with workable tools such as Tricycles; used to
              reach out to rural farmers, deliver farm inputs and monitor
              farmers’ activities, Tablets; used to capture farmer details and
              their farm information, and small handheld implements such as the
              planter, knapsack sprayer, etc to support smallholder farmers.
            </Text>

            <Text fontWeight={"bold"} pl={4} textAlign="center" mb={3}>
              Agripromoter Value Addition
            </Text>

            <View
              style={{
                backgroundColor: "rgba(0,0,0,.2)",
                borderRadius: 20,
                marginHorizontal: 25,
                width: "90%",
                alignSelf: "center",
                marginBottom: 10,
                borderWidth: 1,
                borderColor: "rgba(0,0,0,.2)",
              }}
            >
              {renderContent(SECTIONS[0])}
            </View>

            <View mb={20} mt={10}>
              {/* <Swiper controlsEnabled={true}> */}
              {[
                require("../../assets/man_on_cap.png"),
                require("../../assets/bikes.png"),
              ].map((item, index) => RenderItem({ item, index }))}
              {/* </Swiper> */}
            </View>
          </ScrollView>
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default Agripromoters;

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "#10331b87",
  },
  cardOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
  header: {
    backgroundColor: "rgba(,0,0,.4)",
    padding: 10,
    borderRadius: 20,
    // marginBottom: 20,
  },
  content: {
    padding: 20,
    backgroundColor: "transparent",
    borderRadius: 20,
  },
});
